import axios from 'axios'
// import VueCookies from 'vue-cookies'

const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  },
  timeout: 20000 //Throw error if API call takes longer than 20 sec//
})

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.authorization = 'Bearer '+ token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);


export default {
  postSubscription(subscriptionData) {
    return apiClient.post('/subscription', subscriptionData)
  },
  getSubscription(productId) {
    if (!productId)
      return apiClient.get('/subscription')
    return apiClient.get(`/subscription/${productId}`)
  },
  getSubscriptionPlan() {
    return apiClient.get('/subscription/plan')
  },
  createCustomer() {
    return apiClient.get('/create-customer')
  },
  createSubscription(subscriptionData) {
    return apiClient.post('/create-subscription', subscriptionData)
  },
  updateSubscription(subscriptionData) {
    return apiClient.post('/change/subscription', subscriptionData)
  },
  updateSubscriptionCard(subscriptionData) {
    return apiClient.post('/change/subscription/card', subscriptionData)
  },
  cancelSubscription() {
    return apiClient.get('/cancel/subscription')
  },
  saveFeedback(feedbackJson) {
    return apiClient.post('/feedback', feedbackJson)
  }
}
